export default {"src":"/_next/static/media/profile.cb05fa93.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};